import { CaseTypes } from '@portalCommon/constants';
import classnames from 'classnames/bind';
import { PageTop, TopCard, Demand, Features, Process, Advantage, SuccessCases } from '../components/';
import styles from '../index.module.less';

const cx = classnames.bind(styles);

export const ArtShow = ({ type }: { type: CaseTypes }) => {
  return (
    <>
      <PageTop
        title="艺术展厅解决方案"
        brief="提供专属画廊展厅定制、藏品陈列、作品讲解等多功能于一体的瑶台在线艺术展，期待你的到来。"
        bg="https://static.fuxi.netease.com/yaotai/portal/20220905/l7ohhfyx_477912.png"
      />
      <div className={cx('top-module')}>
        <TopCard type={type}></TopCard>
        <Demand type={type} title={['虚拟世界让艺术', '延伸边界、激发更多创意']} />
      </div>

      <Features type={type} title={['在线艺术展', '特色功能']} subtitle="丰富功能，满足在线艺术展场景需求" />
      <Process></Process>
      <Advantage type={type} title={['艺术展厅', '方案优势']}></Advantage>
      <SuccessCases type={type} title={['成功案例']} subtitle="精彩多样的元宇宙活动，您也可以拥有"></SuccessCases>
    </>
  );
};
